import { RequestError } from '@direct-frontend/modules-request';

/**
 * Возвращает фактический HTTP-статус ошибки запроса, без подстановки при отсутствии ответа.
 * @param error Пойманная ошибка.
 * @returns Статус ответа 100–599 или undefined, если достоверного статуса нет.
 * @kind helper
 */
export function getRequestHttpStatus(error: unknown): number | undefined {
    if (!(error instanceof RequestError)) {
        return undefined;
    }

    const status = error.response?.status;

    if (typeof status !== 'number' || !Number.isInteger(status) || status < 100 || status > 599) {
        return undefined;
    }

    return status;
}
